const baseUrl: string = process.env.REACT_APP_API_URL || '';

class Viedos {
    private uri: string;

    constructor(uri: string) {
        this.uri = uri;
    }

    public read = (params: any) => ({
        baseUrl,
        method: 'get',
        uri: this.uri,
        params
    });

    public readOne = (id: any) => ({
        baseUrl,
        method: 'get',
        uri: `${this.uri}/${id}`,
    });

    public put = (params: any, id: any) => ({
        baseUrl,
        method: 'patch',
        uri: `${this.uri}/${id}`,
        params
    });
}

export default new Viedos('/youtube/v1');



// WEBPACK FOOTER //
// ./src/libraries/api/youtube.tsx